import { ElementBase as s } from "@smartdesign/element-base";
const o = `<style>
	:host {
		display: flex;
		flex-direction: row;
		padding: 24px;
		box-sizing: border-box;
	}

	:host([hidden]) {
		display: none;
	}

	:host([level="info"]) {
		background-color: #e1ebf6;
	}

	:host([level="warn"]) {
		background-color: #fffaeb;
	}

	:host([level="error"]) {
		background-color: #ffe2e5;
	}

	:host([level="success"]) {
		background-color: #eaf4ec;
	}

	:host([hidden-icon]) img {
		display: none;
	}

	.content {
		display: flex;
		flex-direction: column;
		word-wrap: break-word;
		overflow: hidden;
		width: 100%;
	}

	img {
		align-self: flex-start;
		flex-shrink: 0;
		padding-right: 16px;
	}

	.caption-wrapper,
	.description-wrapper {
		display: flex;
	}

	.caption-wrapper {
		font-size: 24px;
		padding-bottom: 8px;
	}

	.description-wrapper {
		font-size: 16px;
		white-space: pre-wrap;
	}

	:host(.no-caption) .caption-wrapper {
		padding-bottom: 0;
	}

	:host(.no-caption) .description-wrapper {
		align-items: center;
		min-height: 32px;
	}
</style>

<img src="" />
<div class="content">
	<div class="caption-wrapper">
		<div class="caption"></div>
		<slot name="caption"></slot>
	</div>

	<div class="description-wrapper">
		<div class="description"></div>
		<slot name="description"></slot>
	</div>
	<div class="footer">
		<slot name="footer"></slot>
	</div>
</div>
`, a = "data:image/svg+xml,%3csvg%20id='svg3363'%20xmlns='http://www.w3.org/2000/svg'%20viewBox='0%200%2032%2032'%20height='32'%20width='32'%3e%3cstyle%3e%20.st0{fill:%23cc0017}%20%3c/style%3e%3cg%20id='layer1'%20transform='translate(0%20-40)'%3e%3cpath%20class='st0'%20d='M16%2042.2c7.6%200%2013.8%206.2%2013.8%2013.8S23.6%2069.8%2016%2069.8%202.2%2063.6%202.2%2056%208.4%2042.2%2016%2042.2m0-1.2C7.7%2041%201%2047.7%201%2056s6.7%2015%2015%2015%2015-6.7%2015-15-6.7-15-15-15z'%20id='path3854'/%3e%3cpath%20id='rect3856'%20class='st0'%20d='M15%2048h2v12h-2z'/%3e%3cpath%20id='rect3860'%20class='st0'%20d='M15%2063h2v2h-2z'/%3e%3c/g%3e%3c/svg%3e", c = "data:image/svg+xml,%3csvg%20id='svg3363'%20xmlns='http://www.w3.org/2000/svg'%20viewBox='0%200%2032%2032'%20height='32'%20width='32'%3e%3cstyle%3e%20.st0{fill:%23105295}%20%3c/style%3e%3cpath%20class='st0'%20d='M16%2029.8C8.4%2029.8%202.2%2023.6%202.2%2016S8.4%202.2%2016%202.2%2029.8%208.4%2029.8%2016%2023.6%2029.8%2016%2029.8m0%201.2c8.3%200%2015-6.7%2015-15S24.3%201%2016%201%201%207.7%201%2016s6.7%2015%2015%2015z'/%3e%3cpath%20id='rect3856'%20class='st0'%20d='M15%2012h2v12h-2z'/%3e%3cpath%20id='rect3860'%20class='st0'%20d='M15%207h2v2h-2z'/%3e%3c/svg%3e", r = "data:image/svg+xml,%3csvg%20id='Ebene_1'%20xmlns='http://www.w3.org/2000/svg'%20viewBox='0%200%2032%2032'%20height='32'%20width='32'%3e%3cstyle%3e%20.st0{fill:%23bf8800}%20%3c/style%3e%3cpath%20class='st0'%20d='M16%201.8l13.8%2024.7v1.6H2.3v-1.6L16%201.8zm1-.8h-2L1%2025.8v3.8h30v-3.8L17%201z'/%3e%3cpath%20class='st0'%20d='M15%2010h2v10h-2zm0%2013h2v2h-2z'/%3e%3c/svg%3e", l = "data:image/svg+xml,%3csvg%20width='32'%20height='32'%20viewBox='0%200%2032%2032'%20fill='none'%20xmlns='http://www.w3.org/2000/svg'%3e%3cpath%20d='M16%2029.8C8.4%2029.8%202.2%2023.6%202.2%2016C2.2%208.4%208.4%202.2%2016%202.2C23.6%202.2%2029.8%208.4%2029.8%2016C29.8%2023.6%2023.6%2029.8%2016%2029.8ZM16%2031C24.3%2031%2031%2024.3%2031%2016C31%207.7%2024.3%201%2016%201C7.7%201%201%207.7%201%2016C1%2024.3%207.7%2031%2016%2031Z'%20fill='%2326A642'/%3e%3cpath%20fill-rule='evenodd'%20clip-rule='evenodd'%20d='M24.4134%2010.9512L13.6667%2022.4656L7.58667%2015.9512L9.04878%2014.5866L13.6667%2019.5344L22.9513%209.58661L24.4134%2010.9512Z'%20fill='%2326A642'/%3e%3c/svg%3e", d = {
  error: a,
  info: c,
  warn: r,
  success: l
}, i = class i extends s {
  set caption(t) {
    t ? this.setAttribute("caption", t) : this.removeAttribute("caption");
  }
  get caption() {
    return this.getAttribute("caption");
  }
  set description(t) {
    t ? this.setAttribute("description", t) : this.removeAttribute("description");
  }
  get description() {
    return this.getAttribute("description");
  }
  get level() {
    return this.getAttribute("level");
  }
  set level(t) {
    t ? this.setAttribute("level", t) : this.setAttribute("level", "info");
  }
  get iconAlt() {
    return this.getAttribute("icon-alt");
  }
  set iconAlt(t) {
    t ? this.setAttribute("icon-alt", t) : this.removeAttribute("icon-alt");
  }
  get hiddenIcon() {
    return this.hasAttribute("hidden-icon") && this.getAttribute("hidden-icon") !== "false";
  }
  set hiddenIcon(t) {
    t ? this.setAttribute("hidden-icon", "") : this.removeAttribute("hidden-icon");
  }
  static get observedAttributes() {
    return ["level", "caption", "description", "icon-alt"];
  }
  is() {
    return i.ID;
  }
  template() {
    const t = document.createElement("template");
    return t.innerHTML = o, t;
  }
  constructor() {
    super(), this.updateNoCaptionStyleName = this.updateNoCaptionStyleName.bind(this);
  }
  connectedCallback() {
    super.connectedCallback(), this.hasAttribute("level") || (this.level = "info"), this.infoImage = this.shadowRoot.querySelector("img"), this.captionElement = this.shadowRoot.querySelector(".caption"), this.descriptionElement = this.shadowRoot.querySelector(".description"), this.captionSlot = this.shadowRoot.querySelector('slot[name="caption"]'), this.captionSlot.addEventListener("slotchange", this.updateNoCaptionStyleName), this.render();
  }
  disconnectedCallback() {
    this.captionSlot.removeEventListener("slotchange", this.updateNoCaptionStyleName);
  }
  attributeChangedCallback() {
    this.render();
  }
  render() {
    this.updateCaption(), this.updateDescription(), this.updateIcon();
  }
  getPathToIcon(t) {
    return d[t];
  }
  updateCaption() {
    this.captionElement && (this.caption ? this.captionElement.innerText = this.caption : this.captionElement.innerText = "", this.updateNoCaptionStyleName());
  }
  updateNoCaptionStyleName() {
    this.caption || this.captionSlot.assignedNodes().length > 0 ? this.classList.remove("no-caption") : this.classList.add("no-caption");
  }
  updateDescription() {
    this.descriptionElement && (this.description ? this.descriptionElement.innerText = this.description : this.descriptionElement.innerText = "");
  }
  updateIcon() {
    this.infoImage && (this.infoImage.src = this.getPathToIcon(this.level) || "", this.infoImage.alt = this.iconAlt || "");
  }
};
i.ID = "sd-message";
let n = i;
var h = /* @__PURE__ */ ((e) => (e.ERROR = "error", e.WARN = "warn", e.INFO = "info", e.SUCCESS = "success", e))(h || {});
customElements.get(n.ID) || customElements.define(n.ID, n);
export {
  h as Level,
  n as Message
};
//# sourceMappingURL=message.mjs.map
